<template>
  <div
    class="video-player"
    v-if="reseted"
    @click="isAuto"
    v-loading="isLoading"
  >
    <video class="video-js" ref="video"></video>
    <div v-if="canAutoPlay" class="model">
      <img
        src="../../assets/images/parent-course/shape-vide.png"
        class="start"
      />
      <img :src="infoObj.coverMaterialUrl" class="model_img" />
      <p>点击屏幕中播放按钮可直接播放~</p>
    </div>
  </div>
</template>
<script>
// lib
import _videojs from "video.js";

const videojs = window.videojs || _videojs;
// as of videojs 6.6.0
const DEFAULT_EVENTS = [
  "loadeddata",
  "canplay",
  "canplaythrough",
  "play",
  "pause",
  "waiting",
  "playing",
  "ended",
  "error",
  "fullscreenchange",
];

// export
export default {
  name: "video-player",
  props: {
    start: {
      type: Number,
      default: 0,
    },
    crossOrigin: {
      type: String,
      default: "",
    },
    infoObj: {
      type: Object,
      default: {},
    },
    playsinline: {
      type: Boolean,
      default: false,
    },
    customEventName: {
      type: String,
      default: "statechanged",
    },
    options: {
      type: Object,
      required: true,
    },
    events: {
      type: Array,
      default: () => [],
    },
    globalOptions: {
      type: Object,
      default: () => ({
        // autoplay: false,
        controls: true,
        // preload: 'auto',
        // fluid: false,
        // muted: false,
        controlBar: {
          remainingTimeDisplay: false,
          playToggle: {},
          progressControl: {},
          fullscreenToggle: {},
          volumeMenuButton: {
            inline: false,
            vertical: true,
          },
        },
        techOrder: ["html5"],
        plugins: {},
      }),
    },
    globalEvents: {
      type: Array,
      default: () => [],
    },
    tipNet: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      player: null,
      reseted: true,
      canAutoPlay: false,
      isLoading: false,
    };
  },
  mounted() {
    if (!this.player) {
      this.initialize();
    }
  },
  beforeDestroy() {
    if (this.player) {
      this.dispose();
    }
  },
  methods: {
    isAuto() {
      if (this.canAutoPlay) {
        // this.isLoading = true
        this.canAutoPlay = false;
        this.player.play();
        // setTimeout(() => {
        //   // this.isLoading = false
        // }, 500)
      }
      // let promise = this.player.play();
      // if (promise !== undefined) {
      //   promise.then(res => {
      //     this.canAutoPlay = false
      //   }).catch(err => {
      //     // 不支持自动播放
      //     this.canAutoPlay = true
      //   })
      // }
    },
    initialize() {
      // videojs options
      const videoOptions = Object.assign({}, this.globalOptions, this.options);

      // ios fullscreen
      if (this.playsinline) {
        this.$refs.video.setAttribute("playsinline", this.playsinline);
        this.$refs.video.setAttribute("webkit-playsinline", this.playsinline);
        this.$refs.video.setAttribute("x5-playsinline", this.playsinline);
        this.$refs.video.setAttribute("x5-video-player-type", "h5");
        this.$refs.video.setAttribute("x5-video-player-fullscreen", false);
      }

      // cross origin
      if (this.crossOrigin !== "") {
        this.$refs.video.crossOrigin = this.crossOrigin;
        this.$refs.video.setAttribute("crossOrigin", this.crossOrigin);
      }

      // emit event
      const emitPlayerState = (event, value) => {
        if (event) {
          this.$emit(event, this.player);
        }
        if (value) {
          this.$emit(this.customEventName, { [event]: value });
        }
      };

      // avoid error "VIDEOJS: ERROR: Unable to find plugin: __ob__"
      if (videoOptions.plugins) {
        delete videoOptions.plugins.__ob__;
      }

      // videoOptions

      // player
      const self = this;
      this.player = videojs(this.$refs.video, videoOptions, function () {
        // events
        const events = DEFAULT_EVENTS.concat(self.events).concat(
          self.globalEvents
        );

        // watch events
        const onEdEvents = {};
        for (let i = 0; i < events.length; i++) {
          if (
            typeof events[i] === "string" &&
            onEdEvents[events[i]] === undefined
          ) {
            ((event) => {
              onEdEvents[event] = null;
              this.on(event, () => {
                emitPlayerState(event, true);
              });
            })(events[i]);
          }
        }
        // watch timeupdate
        this.on("timeupdate", function () {
          emitPlayerState("timeupdate", this.currentTime());
        });

        // player readied
        self.$emit("ready", this);
        if (self.player) {
          let promise = self.player.play();
          if (promise !== undefined) {
            promise
              .then((res) => {
                self.canAutoPlay = false;
              })
              .catch((err) => {
                // 不支持自动播放
                // this.canAutoPlay = true
              });
          }
        }
        // }
      });
    },
    // judge() {
    //   return this.player.play();
    // },
    dispose(callback) {
      if (this.player && this.player.dispose) {
        if (this.player.techName_ !== "Flash") {
          this.player.pause && this.player.pause();
        }
        this.player.dispose();
        this.player = null;
        this.$nextTick(() => {
          this.reseted = false;
          this.$nextTick(() => {
            this.reseted = true;
            this.$nextTick(() => {
              callback && callback();
            });
          });
        });
        /*
          if (!this.$el.children.length) {
            const video = document.createElement('video')
            video.className = 'video-js'
            this.$el.appendChild(video)
          }
          */
      }
    },
  },
  watch: {
    options: {
      deep: true,
      handler(options, oldOptions) {
        this.dispose(() => {
          if (options && options.sources && options.sources.length) {
            this.initialize();
          }
        });
      },
    },
    tipNet: {
      handler(val) {
        var agent = navigator.userAgent.toLowerCase();
        var iphone = agent.indexOf("iphone");
        var weixin = agent.indexOf("micromessenger");
        this.isLoading = true;
        if (val) {
          if (iphone > -1 && weixin > -1) {
            this.canAutoPlay = true;
          } else {
            this.canAutoPlay = false;
          }
        } else {
          this.canAutoPlay = true;
        }
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
      },
      immediate: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.video-player {
  position: relative;
  .model {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    .model_img {
      height: 100%;
      width: 100%;
    }
    p {
      position: absolute;
      left: 30%;
      top: 70%;
      transform: translate(-20%, -10%);
      color: #fff;
      // font-size: 16px;
    }
    .start {
      width: 40px;
      height: 40px;
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>
